import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, SpaceBetween } from "@cloudscape-design/components";

const NoPermission: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
        padding: "40px 20px",
      }}
    >
      <SpaceBetween size="l" direction="vertical" alignItems="center">
        <div
          style={{
            fontSize: "60px",
            fontWeight: 700,
            lineHeight: 1,
            color: "#d91515",
            userSelect: "none",
          }}
        >
          No Permission
        </div>
        {/* <Box textAlign="center" variant="h2">
          Access Denied
        </Box> */}
        <Box textAlign="center" color="text-body-secondary" fontSize="body-m">
          You don't have permission to access this page. Please contact an administrator below to request access.
        </Box>
        <div
          style={{
            background: "#f4f4f4",
            borderRadius: "8px",
            padding: "16px 24px",
            textAlign: "center",
          }}
        >
          <Box variant="h4" margin={{ bottom: "xs" }}>
            Admin Contacts
          </Box>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "8px 16px",
            }}
          >
            {[
              "sujiache",
              "mkzhao",
              "yuhayanv",
              "wwutong",
              "psyajing",
            ].map((login) => (
              <a
                key={login}
                href={`https://phonetool.amazon.com/users/${login}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#0972d3",
                  textDecoration: "underline",
                  fontSize: "14px",
                }}
              >
                {login}
              </a>
            ))}
          </div>
        </div>
        <Button variant="primary" onClick={() => navigate("/")}>
          Back to Home
        </Button>
      </SpaceBetween>
    </div>
  );
};

export default NoPermission;
